import slideIt from './slider.js'
import initNews from './news.js'

slideIt('#slider', 7000)

initNews() 